const md5 = require('md5');

export default {
  props: ['step', 'authPage'],
  methods: {
    back() {
      if (this.authPage) {
        const checkout = this.checkout;
        checkout.authType = checkout.orderAsGuest ? 'guest' : null;

        this.$store.dispatch('SET_CHECKOUT', checkout);
        this.$router.push(this.i18nLink('checkout'));
      } else if (this.checkoutStep === 1 || this.checkoutStep === 2 &&
          this.user) {
        this.$router.push(this.i18nLink('cart'));
      } else if (this.checkout.authType === 'registration') {
        this.$router.push(this.i18nLink('registration'));
      } else {
        let prevStep = 1;

        if (this.checkoutStep === 5 && !this.$store.getters.COUPONS_ENABLED) {
          prevStep = this.checkout.shippingOption ? 2 : 3;
        }

        if (this.checkoutStep === 6) {
          if (!this.checkout.shippingOption) {
            prevStep = 4;
          } else if (!this.checkout.paymentOption) {
            prevStep = 2;
          }
        }

        let checkoutStep = this.checkoutStep - prevStep;

        if (checkoutStep === 3 && this.tmpOrder.flags && +this.tmpOrder.flags.contains_only_downloads) {
          checkoutStep--;
        }

        this.$store.dispatch('SET_CHECKOUT_STEP', checkoutStep);
      }
    },
    async next() {
      let checkout, order;

      switch (this.checkoutStep) {
        case 2:
          checkout = this.checkout;
          checkout.personalData = true;

          this.$store.dispatch('SET_CHECKOUT', checkout);
          break;
        case 4:
          this.$store.dispatch('SET_CHECKOUT_STEP',
              +this.tmpOrder.grandtotal === 0 ? 6 : this.checkoutStep + 1);
          break;
        case 6:
          if (this.checkout.paymentOption) {
            switch (this.checkout.paymentOption.payment_option.id) {
              case '2':
              case '3':
              case '4':
              case '6':
                order = await this.orderProcess();

                if (order) {
                  this.goToProviders(order);
                } else {
                  this.toast(this.$t('error'), order, 'danger');
                }
                break;
              default:
                order = await this.orderProcess();

                if (order) {
                  this.$router.push(this.i18nLink(`complete/order/${order}`));
                } else {
                  this.toast(this.$t('error'), order, 'danger');
                }
            }
          } else {
            order = await this.orderProcess();

            if (order) {
              this.$router.push(this.i18nLink(`complete/order/${order}`));
            } else {
              this.toast(this.$t('error'), order, 'danger');
            }
          }
      }
    },
    async goToProviders(orderId) {
      if (this.checkout.paymentOption.payment_option.id === '2' || this.checkout.paymentOption.payment_option.id === '3') {
        this.$loading.show();

        let config, params;

        const data = this.tmpOrder;
        const form = document.createElement('form');
        const total = parseFloat(data.total_price) +
            parseFloat(data.shipping_cost) +
            parseFloat(data.shipping_surcharges) || 0;

        form.method = 'POST';
        form.style.display = 'none';

        if (this.checkout.paymentOption.payment_option.id === '2') {
          config = this.paymentConfigs.sofort;
          form.action = 'https://www.sofort.com/payment/start';

          const hashArr = [
            config.id, // user id
            config.project_id, // project id
            '', // acc holder name
            '', // sender IBAN
            '', // sender BIC
            '', // sender country
            total, // amount
            config.currency_code, // currency id
            this.coreParams.title, // reason 1
            `${this.$t('order')} #${orderId}`, // reason 2
            this.returnUrl(this.$router.currentRoute.path, false), // user var 0
            orderId, // user var 1
            config.notify_url, // user var 2
            process.env.VUE_APP_IS_PRODUCTION === 'true' ? 'production' : 'test', // user var 3
            '', // user var 4
            '', // user var 5
            process.env.VUE_APP_SOFORT_NOTIFICATION_PASSWORD // password
          ];

          const hash = md5(hashArr.join('|'));

          params = [
            {name: 'amount', value: total},
            {name: 'currency_id', value: config.currency_code},
            {name: 'reason_1', value: this.coreParams.title},
            {name: 'reason_2', value: `${this.$t('order')} #${orderId}`},
            {name: 'user_id', value: config.id},
            {name: 'project_id', value: config.project_id},
            {name: 'hash', value: hash},
            {
              name: 'user_variable_0',
              value: this.returnUrl(this.$router.currentRoute.path, false)
            },
            {name: 'user_variable_1', value: orderId},
            {name: 'user_variable_2', value: config.notify_url},
            {name: 'user_variable_3', value: process.env.VUE_APP_IS_PRODUCTION === 'true' ? 'production' : 'test'},
          ];
        } else if (this.checkout.paymentOption.payment_option.id === '3') {
          config = this.paymentConfigs.paypal;
          form.action = config.url;

          params = [
            {name: 'business', value: config.id},
            {
              name: 'image_url',
              value: this.coreParams.shop_asset_image.logo_original
            },
            {name: 'cmd', value: '_xclick'},
            {name: 'charset', value: 'utf-8'},
            {name: 'amount', value: total},
            {name: 'currency_code', value: config.currency_code},
            {name: 'item_name', value: 'Bildkopie Order'},
            {
              name: 'return',
              value: this.returnUrl(
                  `${this.$router.currentRoute.path}/payment/success`)
            },
            {
              name: 'cancel_return',
              value: this.returnUrl(
                  `${this.$router.currentRoute.path}/payment/abort`)
            },
            {name: 'notify_url', value: config.notify_url},
            {name: 'first_name', value: this._.first(data.addresses).first_name},
            {name: 'last_name', value: this._.first(data.addresses).last_name},
            /*{name: 'address1', value: this._.first(data.addresses).house_number},*/
            {name: 'address1', value: this._.first(data.addresses).street},
            {
              name: 'state',
              value: data.addresses && data.addresses.length > 0 ? this._.first(
                  data.addresses).country.iso_code : this.$i18n.locale
            },
            {name: 'city', value: this._.first(data.addresses).city},
            {name: 'zip', value: this._.first(data.addresses).zip},
            {name: 'email', value: this._.first(data.addresses).email},
            {name: 'custom', value: `${orderId}`},
          ];
        }

        params.forEach(param => {
          form.appendChild(this.createHiddenElement(param.name, param.value));
        });

        document.body.appendChild(form);

        form.submit();
        form.remove();
      } else if (['4', '6'].includes(this.checkout.paymentOption.payment_option.id)) {
        const loader = this.$loading.show();

        try {
          const response = await this.axios.post(`v2/${this.checkout.paymentOption.payment_option.id === '4' ? 'mpay' : 'mollie'}`, {
            id: orderId
          });

          if (response && response.data && response.data.success) {
            window.location.href = response.data.data.location;
          } else {
            loader.hide();
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
          loader.hide();
        }
      }
    },
    returnUrl(path = '', protocol = true) {
      return `${protocol ? `${window.location.protocol}//` : ''}${window.location.host}${path}`;
    },
    createHiddenElement(name, value) {
      const input = document.createElement('input');

      input.type = 'hidden';
      input.name = name;
      input.value = value;

      return input;
    },
  },
};
